module.exports = __webpack_public_path__ + "6e6c4fbf4c4b83edc346122eba393acd.svg";